// @flow
// $FlowFixMe
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import Search from '../../search/QuickSearch';
import MainMenu from '../MainMenu';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import type { intlShape } from 'react-intl';
import { compose } from 'redux';
import { useDesktopMediaQuery } from '../../../utils/useMediaQuery';

import ProgressBar from '../ProgressBar';

import { showModal as showModalActionCreator } from '../../../actions/ui';
import { logout as logoutActionCreator } from '../../../actions/auth';
import { track as analyticsActionCreator } from '../../../actions/analytics';
import * as routerActionCreators from 'react-router-redux';

import {
  selectUserCanSubscribe,
  selectUserIsAuthenticated,
  selectUserPlan,
  // selectUserPlanSubscriptionType,
} from '../../../selectors/user';
import {
  selectIsWindows,
  selectChrome,
  selectIsMobile,
  selectIsMac,
  selectIsGeoBlockedCountry,
} from '../../../selectors/client';
import { selectCtaTrackingContext } from '../../../selectors/tracking';

import styles from './AppHeader.css';
import IconLabel from '../../util/IconLabel.js';

import {
  CHROMES_HIDE_SEARCH,
  CHROME_CLEAN,
  CHROMES_HIDE_MENU,
  ANONYMOUS_ONLY_PATHS,
} from '../../../constants.js';

import { unwrapRouteComponent } from '../../../utils/unwrapRouteComponent';

import AccountLogin from '../../messages/AccountLogin';
import AccountJoin from '../../messages/AccountJoin';
import GetPremiumButton from '../../common/GetPremiumButton';
import { commonMessages } from '../../messages/Common';

const BACK = -1;
const FORWARD = 1;

declare var __ELECTRON__: boolean;

type OwnProps = {
  location: Object,
};

type MapStateToProps = {
  canGo: Function,
  isAuthenticated: boolean,
  isWindows: boolean,
  isMac: boolean,
  isGeoBlocked: boolean,
  trackingContext: Object,
  isJoinPage: boolean,
  userCanSubscribe: boolean,
  // userPlanSubscriptionType: string,
  userPlan: string,
  chrome: string,
};

type DispatchProps = {
  showModal: Function,
  logout: Function,
  track: Function,
  back: Function,
  forward: Function,
};

type Props = OwnProps &
  MapStateToProps &
  DispatchProps & {
    intl: intlShape,
  };

const AppHeader = ({
  isAuthenticated,
  isWindows,
  isMac,
  isGeoBlocked,
  showModal,
  logout,
  userCanSubscribe,
  // userPlanSubscriptionType,
  userPlan,
  track,
  back,
  forward,
  canGo,
  chrome,
  trackingContext,
  location,
  isJoinPage,
  intl,
}: Props) => {
  const [isDesktopView, setIsDesktopView] = useState(false);

  const isDesktopMediaQuery = useDesktopMediaQuery();
  useEffect(() => {
    setIsDesktopView(isDesktopMediaQuery);
  }, [isDesktopMediaQuery]);

  const showLoginModal = event => {
    event.preventDefault();
    showModal('LOGIN_MODAL', { trigger: 'appheader' });
  };

  // const showUpgradeModal = event => {
  //   event.preventDefault();
  //   showModal('UPGRADE_MODAL', {
  //     trigger: 'appheader',
  //     plan: userPlan,
  //     payment_gateway: userPlanSubscriptionType,
  //   });
  // };

  const showSignupModal = event => {
    event.preventDefault();
    showModal('SIGNUP_MODAL', { trigger: 'appheader' });
  };

  const onSignupClick = event => {
    showSignupModal(event);
    track('Clicked Signup Button', trackingContext);
  };

  const goForward = () => {
    forward();
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  const goBack = () => {
    back();
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  const LogoSvg = () => {
    return (
      <svg version="1.1" x="0px" y="0px" width="88px" height="104px" viewBox="0 0 88 104">
        <rect x="40" y="80" fill="#2F323D" width="48" height="24" />
        <polygon fill="#2F323D" points="0,0 0,80 64,40 " />
      </svg>
    );
  };

  const renderLogoOrArrows = () => {
    if (__ELECTRON__) {
      const classesIcon = classnames(styles.icon, 'c-icon--label-false');
      const arrowLeftClasses = classnames(classesIcon, {
        'is-active': canGo(BACK),
      });
      const arrowRightClasses = classnames(classesIcon, {
        'is-active': canGo(FORWARD),
      });
      return (
        <span className={styles.navArrows}>
          <button onClick={goBack} aria-label={intl.formatMessage(commonMessages.back)}>
            <IconLabel name="chevron-left" className={arrowLeftClasses} />
          </button>
          <button onClick={goForward} aria-label={intl.formatMessage(commonMessages.forward)}>
            <IconLabel name="chevron-right" className={arrowRightClasses} />
          </button>
        </span>
      );
    }
    const classesLogo = classnames(styles.logo, 'u-hide-text');

    return isAuthenticated ? (
      <Link to="/discover" className={classesLogo} title="IDAGIO Discover">
        <LogoSvg />
      </Link>
    ) : (
      <Link to="/" className={classesLogo} title="IDAGIO">
        <LogoSvg />
      </Link>
    );
  };

  const renderRightSideCtas = () => {
    if (isGeoBlocked) {
      return null;
    }

    if (isAuthenticated) {
      if (!userCanSubscribe) {
        return null;
      }

      return (
        <GetPremiumButton
          className={classnames(styles.subscribeButton, {
            'c-btn': isDesktopView,
            'c-btn--is-purple': isDesktopView,
          })}
          trackingContext={{ trigger: 'appheader', plan: userPlan }}
          data-test="header.subscribe-btn"
          showText={isDesktopView}
          iconName={isDesktopView ? 'premium-transparent' : 'premium-filled'}
          targetPlan=""
          onClick={() => {}}
        />
      );
    }

    let queryParams = '';
    if (location) {
      const to = `/${location.pathname}${location.search}`;
      queryParams = ANONYMOUS_ONLY_PATHS.includes(location.pathname)
        ? location.search
        : `?to=${encodeURIComponent(to)}`;
    }

    return (
      <div className={styles.rightLinks}>
        {!__ELECTRON__ && (
          <Link
            to={`/login${queryParams}`}
            className={classnames(styles.link, styles.loginLink)}
            activeClassName="is-active"
            onClick={showLoginModal}
            data-test="header.show-login-modal-btn"
          >
            <AccountLogin />
          </Link>
        )}
        {!__ELECTRON__ && !isJoinPage && (
          <Link
            to={`/join${queryParams}`}
            onClick={onSignupClick}
            className={classnames('c-btn', 'c-btn--is-purple', styles.createAccountButton)}
            data-test="header.show-join-modal-btn"
          >
            <AccountJoin />
          </Link>
        )}
      </div>
    );
  };

  const headerClassNames = classnames(styles.component, {
    [styles.isWindows]: isWindows,
    [styles.isMacDesktop]: __ELECTRON__ && !isWindows,
    [styles.hasShadow]: !__ELECTRON__ || isAuthenticated,
  });

  const chromeHidesSearch = CHROMES_HIDE_SEARCH.includes(chrome);
  const chromeHidesRight = CHROME_CLEAN.includes(chrome);
  const chromeHidesMenu = CHROMES_HIDE_MENU.includes(chrome);

  return (
    <header className={headerClassNames} id="app-header">
      {__ELECTRON__ && (
        <div
          className={classnames(styles.draggable, styles.draggableTop)}
          id="app-header-draggable-top"
        />
      )}
      {__ELECTRON__ && isAuthenticated && (
        <div
          className={classnames(styles.draggable, styles.draggableLeft)}
          id="app-header-draggable-left"
        />
      )}
      <div className={styles.inner}>
        <div className={styles.left}>{renderLogoOrArrows()}</div>
        {!chromeHidesSearch && (
          <div className={styles.center}>
            <Search />
          </div>
        )}
        {!chromeHidesRight && (
          <div className={styles.right}>
            {renderRightSideCtas()}
            {!chromeHidesMenu && (
              <MainMenu
                isAuthenticated={isAuthenticated}
                logout={logout}
                isMac={isMac}
                isWindows={isWindows}
                showSubscribeButton={isAuthenticated && userCanSubscribe && !isDesktopView}
              />
            )}
          </div>
        )}
      </div>
      <ProgressBar />
    </header>
  );
};

function mapStateToProps(
  state: Object,
  ownProps: OwnProps & { params: { slug: string }, router: Object, routes: Object }
): MapStateToProps {
  const { slug } = ownProps.params;
  const routeComponentName = unwrapRouteComponent(ownProps.routes).displayName;

  return {
    canGo: ownProps.router.canGo,
    isAuthenticated: selectUserIsAuthenticated(state),
    isWindows: selectIsWindows(state),
    isMac: selectIsMac(state),
    isMobile: selectIsMobile(state),
    chrome: selectChrome(state),
    isGeoBlocked: selectIsGeoBlockedCountry(state),
    trackingContext: selectCtaTrackingContext(state, slug, routeComponentName),
    isJoinPage: ownProps.location.pathname === 'join',
    userCanSubscribe: selectUserCanSubscribe(state),
    // userPlanSubscriptionType: selectUserPlanSubscriptionType(state),
    userPlan: selectUserPlan(state),
  };
}

const dispatchProps: DispatchProps = {
  showModal: showModalActionCreator,
  logout: logoutActionCreator,
  track: analyticsActionCreator,
  forward: routerActionCreators.goForward,
  back: routerActionCreators.goBack,
};

export { AppHeader as ShallowAppHeader };

export default compose(withRouter, connect(mapStateToProps, dispatchProps), injectIntl)(AppHeader);
